import { rgba } from 'polished';
import styled from 'styled-components';
import { StyledWrapper } from '../common/Wrapper/Wrapper.styles';
import { theme } from '../../styles/config/theme';
import { typeStyle } from '../../styles/config/typeStyles';
import media from '../../styles/config/mediaQueries';
import { Link } from 'react-router-dom';

const StyledFooter = styled.footer`
  width: 100%;
  border-top: 1px solid ${rgba(theme.color.white, 0.2)};

  ${StyledWrapper} {
    display: flex;
    max-width: 1162px;
    position: relative;
  }
  ${media.desktop`
    ${StyledWrapper} {
      padding: 54px 26px;
    }
  `}
`;

const StyledFooterDescription = styled.div`
  margin-right: 234px;

  svg {
    margin-bottom: 23px;
  }
`;

const StyledFooterText = styled.p`
  ${typeStyle['font-14']}
  max-width: 238px;
  margin-bottom: 47px;
`;

const StyledFooterCopy = styled.span`
  ${typeStyle['font-14']}
  opacity: 0.7;
`;

const StyledCopyLink = styled.a`
  font-weight: 700;
`;

const StyledFoooterList = styled.ul`
  min-width: 128px;
  margin-right: 62px;
`;

const StyledFooterCategory = styled.li`
  ${typeStyle['font-14-bold']}
  margin-bottom: 14px;
`;

const StyledFooterItem = styled.li`
  margin-bottom: 10px;
  &:hover {
    opacity: 0.6;
  }
`;

const StyledFooterLink = styled(Link)`
  ${typeStyle['font-14']}
`;

const StyledFooterAnchor = styled.a`
  ${typeStyle['font-14']}
`;

const StyledButton = styled.button`
  position: absolute;
  bottom: 52px;
  right: 26px;
  min-height: 43px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  &:hover {
    opacity: 0.6;
  }

  svg {
    transform: rotate(-90deg);
    width: 16px;
  }
`;

export {
  StyledFooter,
  StyledFooterDescription,
  StyledFooterText,
  StyledFooterCopy,
  StyledFoooterList,
  StyledCopyLink,
  StyledFooterCategory,
  StyledFooterItem,
  StyledFooterLink,
  StyledFooterAnchor,
  StyledButton,
};
